import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Textarea,
} from "@chakra-ui/react";
import { useCallback, useRef } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useUpdateHomeworkStatus from "../../hooks/api/homework/useUpdateHomeworkStatus";
import ConfirmDialog, { ConfirmDialogHandle } from "../ConfirmDialog";

type Props = {
  homeworkId: string;
  refetchHomework: () => void;
};

type FormValues = {
  message: string;
};

export default function ApproveHomeworkButton({
  homeworkId,
  refetchHomework,
}: Props) {
  const { t } = useTranslation();
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<FormValues>();
  const { mutateAsync: approveHomework, isPending: isApproveHomeworkLoading } =
    useUpdateHomeworkStatus(homeworkId);
  const confirmDialogRef = useRef<ConfirmDialogHandle>(null);

  const onApproveConfirmed = useCallback(() => {
    handleSubmit(({ message }) =>
      approveHomework({
        status: { status: "APPROVED", message },
      }).then(refetchHomework),
    )();
  }, [approveHomework, handleSubmit, refetchHomework]);

  return (
    <>
      <Button
        bg="primary.DEFAULT"
        color="white"
        onClick={() => confirmDialogRef.current?.open()}
        isLoading={isApproveHomeworkLoading}
      >
        {t("common.buttons.approve")}
      </Button>
      <ConfirmDialog
        ref={confirmDialogRef}
        title={t("homework_page.approval")}
        message={t("homework_page.approval_message")}
        onConfirm={onApproveConfirmed}
        isLoading={isApproveHomeworkLoading}
        bodyContent={
          <form>
            <FormControl flexGrow={1} mt={4}>
              <FormLabel hidden htmlFor="message">
                {t("forms.message")}
              </FormLabel>
              <Textarea
                {...register("message")}
                rows={4}
                id="message"
                placeholder={t("forms.message")}
              />
              <FormErrorMessage>
                {errors.message && errors.message.message}
              </FormErrorMessage>
            </FormControl>
          </form>
        }
      />
    </>
  );
}
